import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { Button } from './ui/button';
import { faqs } from '../mock';

const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-5">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#FF5C39] mb-3">Your questions</div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1F0068] tracking-tight leading-tight">
            We’re here to help
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={f.q} className="rounded-2xl bg-[#FFF6EB] border border-[#1F0068]/5 overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center gap-4 p-5 md:p-6 text-left">
                <span className="flex-1 font-bold text-[#1F0068] text-base md:text-lg">{f.q}</span>
                <span className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-colors ${open === i ? 'bg-[#FF5C39] text-white' : 'bg-white text-[#1F0068]'}`}>
                  {open === i ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </span>
              </button>
              <div className={`grid transition-all duration-300 ${open === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                <div className="overflow-hidden">
                  <p className="px-5 md:px-6 pb-6 text-[#1F0068]/75 leading-relaxed">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <Button variant="outline" className="squircle h-12 px-7 border-[#1F0068] text-[#1F0068] hover:bg-[#1F0068] hover:text-white font-semibold">
            See our help page
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
